import { action, makeObservable, observable } from 'mobx';

class GameStore {
  isBetsClosed = false;

  numPadData = { isOpen: false, sectionName: null, currentInputValue: null };

  timerDuration = 10;

  finishedResult = null;

  stopLight = false;

  pastRoundsData = [];

  isLoadingPage = false;

  margin = 0;

  gameState = {
    status: '',
    isInitialLoaded: false,
  };

  constructor() {
    makeObservable(this, {
      margin: observable,
      gameState: observable,
      stopLight: observable,
      isBetsClosed: observable,
      timerDuration: observable,
      isLoadingPage: observable,
      finishedResult: observable,
      numPadData: observable.deep,
      pastRoundsData: observable.deep,
      setMargin: action.bound,
      setGameState: action.bound,
      setStopLight: action.bound,
      setNumPadData: action.bound,
      setIsBetsClosed: action.bound,
      setIsLoadingPage: action.bound,
      setTimerDuration: action.bound,
      setFinishedResult: action.bound,
      setPastRoundsData: action.bound,
      updatedPastRoundsData: action.bound,
    });
  }

  setIsBetsClosed(isBetsClosed) {
    this.isBetsClosed = isBetsClosed;
  }

  // statistics
  setNumPadData(data) {
    this.numPadData = data;
  }

  setFinishedResult(result) {
    this.finishedResult = result;
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  setGameState(status) {
    this.gameState = status;
  }

  setMargin(margin) {
    this.margin = margin;
  }

  setPastRoundsData(data) {
    this.pastRoundsData = data.reverse();
    if (this.pastRoundsData.length >= 8) {
      this.pastRoundsData.shift();
    }
  }

  setStopLight(boolean) {
    this.stopLight = boolean;
  }

  updatedPastRoundsData(roundData) {
    this.pastRoundsData.push(roundData);
    // if (this.pastRoundsData.length >= 8) {
    //   setTimeout(() => {
    //     this.setPastRoundsData(this.pastRoundsData.slice(-7));
    //   }, 500);
    // }
  }

  setIsLoadingPage(isLoadingPage) {
    this.isLoadingPage = isLoadingPage;
  }

  updateIsFakeImagesLoaded(fakeImagesLoadedCount, fakeImagesCount) {
    this.isFakeImagesLoaded = fakeImagesLoadedCount === fakeImagesCount;
  }
}

export const gameStore = new GameStore();
